import React from 'react';
import { CheckIcon, DownloadIcon, PrinterIcon, StarIcon } from 'lucide-react';
import { CtaButton } from './ui/CtaButton';
import { BUNDLE_MOCKUP, heroBullets, PRICE_LABEL } from '../data/content';
const chips = [{
  icon: DownloadIcon,
  label: 'Lo descargás hoy'
}, {
  icon: PrinterIcon,
  label: 'PDF listo para imprimir'
}];
export function Hero() {
  return <header className="bg-ink text-cream" data-id="element-113" data-mp="4jvyzk2o7p0h">
      <div className="mx-auto flex min-h-[calc(100svh-44px)] max-w-5xl flex-col justify-center px-5 py-10 text-center lg:py-12" data-id="element-114" data-mp="128fq7kfogfw8">
        <p className="flex items-center justify-center gap-3 text-[11px] font-semibold uppercase tracking-eyebrow text-cream/70" data-id="element-115" data-mp="xb5rtfab8tw9">
          <span aria-hidden="true" className="h-0.5 w-7 bg-amber" data-id="element-116" data-mp="nc87kojx3mj2" />
          Método para profesores de guitarra
        </p>

        <h1 className="mx-auto mt-5 max-w-4xl font-condensed text-4xl uppercase leading-[0.92] tracking-tight sm:text-5xl lg:text-6xl" data-id="element-117" data-mp="3d1sc51sntrv8">
          Planificá todo tu trimestre
          <span className="mt-1 block text-amber" data-id="element-118" data-mp="3j8iv8twpu6s2">de clases de guitarra</span>
        </h1>

        <p className="mx-auto mt-4 max-w-2xl font-display text-base italic leading-snug text-cream/75 sm:text-lg" data-id="element-119" data-mp="3o7lshs6gf8ph">
          El sistema «Imprimí y enseñá» que convierte tu planificación de{' '}
          <span className="text-amber" data-id="element-120" data-mp="39cpain8uf6z7">caótica</span> en <span className="text-amber" data-id="element-121" data-mp="3e8egb8bghk3y">obvia</span>.
        </p>

        <figure className="relative mx-auto mt-7 w-full max-w-3xl" data-id="element-122" data-mp="30i158x39ppae">
          <img src={BUNDLE_MOCKUP} alt="Mockup del método completo: el curso en pantalla junto a los 6 bonos en tablets, atados con un moño de regalo" className="mx-auto max-h-[38vh] w-full rounded-2xl border border-cream/15 object-contain shadow-lift" data-id="element-123" data-mp="30gq1uydqijjt" />
          <figcaption className="absolute -top-3 right-4 rounded-full bg-amber px-4 py-1.5 text-[11px] font-bold uppercase tracking-eyebrow text-ink shadow-card" data-id="element-124" data-mp="2vgu075sif47f">
            6 volúmenes + 6 bonos
          </figcaption>
        </figure>

        <div className="mx-auto mt-8 w-full max-w-xl" data-id="element-125" data-mp="s1rt2qgj2avc">
          <CtaButton data-id="element-126" data-mp="s3cmudv0pps5">Quiero el pack completo por {PRICE_LABEL}</CtaButton>
        </div>

        <div className="mt-5 flex flex-wrap items-center justify-center gap-x-5 gap-y-3" data-id="element-127" data-mp="n9qjjcaquy90">
          {chips.map(chip => <span key={chip.label} className="inline-flex items-center gap-2 text-[13px] text-cream/80" data-id="element-128" data-mp="i9vrh5f8g2md">
              <chip.icon aria-hidden="true" className="h-3.5 w-3.5 text-amber" data-id="element-129" data-mp="1b15lv52itfk9" />
              {chip.label}
            </span>)}
          <span className="inline-flex items-center gap-2 text-[13px] text-cream/80" data-id="element-130" data-mp="162m47guympxp">
            <span aria-hidden="true" className="flex items-center gap-0.5" data-id="element-131" data-mp="111525i0qoxfj">
              {[0, 1, 2, 3, 4].map(star => <StarIcon key={star} className="h-3.5 w-3.5 fill-amber text-amber" data-id="element-132" data-mp="x3h260k6wegs" />)}
            </span>
            <span className="font-semibold text-cream" data-id="element-133" data-mp="3hrlmgnykwhbm">4,9/5</span>
            <span data-id="element-134" data-mp="3htg8y6pi0hht">· 1.283 profes</span>
          </span>
        </div>
      </div>

      <div className="border-t border-cream/10" data-id="element-135" data-mp="1xavxukzeea7s">
        <ul className="mx-auto grid max-w-6xl gap-x-8 gap-y-3 px-5 py-7 sm:grid-cols-2 lg:grid-cols-3" data-id="element-136" data-mp="21amwfav61umv">
          {heroBullets.map(bullet => <li key={bullet} className="flex items-start gap-2.5 text-[15px] text-cream/85" data-id="element-137" data-mp="268g282sk4mmm">
              <CheckIcon aria-hidden="true" className="mt-0.5 h-4 w-4 shrink-0 text-amber" data-id="element-138" data-mp="2b1hjghg8ky9d" />
              <span data-id="element-139" data-mp="2fz0wje1774zq">{bullet}</span>
            </li>)}
        </ul>
      </div>
    </header>;
}